<template>
    <div class="card-wrap" :class="classes ? classes.root : ''">
        <slot name="header"></slot>
        <slot></slot>
        <slot name="footer"></slot>
    </div>
</template>

<style scoped>
    .card-wrap{
        padding: 10px;
        border: 1px solid rgb(202, 202, 202);
        margin: 10px 0;
        border-radius: 6px;
        box-shadow: 1px 1px 8px 1px #ccc;
    }
</style>

<script>
export default {
    props: {
        classes: { type: Object }
    }
}
</script>
